import script from "./DetailRequestIncorrectData.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequestIncorrectData.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequestIncorrectData.vue?vue&type=style&index=0&id=000594d2&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000594d2"]])

export default __exports__